export const selectIsLogged = ({user}) => user.is_authenticated;
export const selectIsVolunteer = ({user, sheet}) => user.userId !== sheet.organizer_id;
